<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :show-close="false"
    :subject="subject"
    :theme="currentTheme"
    showCancelBtn
    @on-confirm="confirmHandler"
  >
    <template slot="subtitle">
      <div>
        <p style="text-align: center">{{ actionLabel }}</p>
        <p style="color: blue">{{ item.title }}</p>
      </div>
    </template>
    <el-row>
      <div>
        <span>{{ $t("component.dialog.publisher") }}：</span>
        <span>{{ username }}</span>
      </div>
    </el-row>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";
import apis from "@/apis";

const api = apis.tg_business.announcement.review;

// const actionTxtMap = {
//   pass: "通過",
//   up: "上架",
//   down: "下架",
//   veto: "否決",
// };

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  props: {
    item: Object,
  },
  computed: {
    action() {
      return this.item.action;
    },
    isAccept() {
      return ["pass", "up"].indexOf(this.action) > -1;
    },
    currentTheme() {
      return this.isAccept ? "info" : "warning";
    },
    subject() {
      return this.$t("component.dialog.subject.announcement");
    },
    subtitle() {
      return (
        this.actionLabel +
        "<br><span style='color: gray;'>" +
        this.item.title +
        "</span>"
      );
    },
    actionLabel() {
      let langKey = "component.dialog.status.announcement." + this.action;
      return this.$t(langKey);
    },
    username() {
      return this.item.creator;
    },
  },
  methods: {
    confirmHandler() {
      api[this.item.action](this.item.id)
        .then((response) => {
          if(response.retcode == 0){
            this.$emit("on-success", this.$t("statusCode["+response.retcode+"]"));
          }
        })
        .catch(() => {
          this.$refs.dialog.close();
        });
    },
  },
};
</script>
